
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-neutral-100">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/d7da4bfde00f775727e3be13864eec4a.png" 
              alt="Bellport Branding - Long Island Website Design Agency" 
              title="Long Island Website Design and Video Production"
              className="h-8 w-auto mb-6"
            />
            <p className="text-sm text-neutral-500 leading-relaxed mb-4">
              Long Island's trusted digital agency for small businesses. Website design, video production, and digital marketing in Nassau & Suffolk County.
            </p>
            <a 
              href="tel:+16316407888"
              className="inline-flex items-center gap-2 text-lg font-semibold text-neutral-900 hover:text-[#1E3A8A] transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-[#1E3A8A]"></i>
              (631) 640-7888
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-neutral-900 mb-6">
              <a href="#services" className="hover:text-[#1E3A8A] transition-colors cursor-pointer">Services</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/website-design-long-island"
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Long Island Web Design
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Website Design
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Ethical Hacking
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Social Media
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Videography
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Video Editing
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-neutral-900 mb-6">
              <a href="#service-areas" className="hover:text-[#1E3A8A] transition-colors cursor-pointer">Service Areas</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Nassau County
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Suffolk County
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Huntington
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Babylon
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  Islip
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-neutral-900 mb-6">
              <a href="#start-project" className="hover:text-[#1E3A8A] transition-colors cursor-pointer">Get Started</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:+16316407888"
                  className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-phone-line"></i>
                  (631) 640-7888
                </a>
              </li>
              <li>
                <a href="mailto:info@bellportbranding.com" className="text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  info@bellportbranding.com
                </a>
              </li>
              <li className="flex gap-4 pt-4">
                <a
                  href="https://www.BellportBranding.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-neutral-200 flex items-center justify-center text-neutral-600 hover:bg-[#1E3A8A] hover:text-white transition-all cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="https://www.BellportBranding.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-neutral-200 flex items-center justify-center text-neutral-600 hover:bg-[#1E3A8A] hover:text-white transition-all cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a
                  href="https://www.BellportBranding.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-neutral-200 flex items-center justify-center text-neutral-600 hover:bg-[#1E3A8A] hover:text-white transition-all cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-neutral-400">
            © 2026 Bellport Branding · Long Island Website Design & Video Production
          </p>
          <div className="flex gap-6">
            <a href="https://www.BellportBranding.com" className="text-sm text-neutral-400 hover:text-neutral-600 transition-colors cursor-pointer">
              Privacy
            </a>
            <a href="https://www.BellportBranding.com" className="text-sm text-neutral-400 hover:text-neutral-600 transition-colors cursor-pointer">
              Terms
            </a>
            <a
              href="https://www.instagram.com/danmcbabe/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-sm text-neutral-400 hover:text-neutral-600 transition-colors cursor-pointer"
            >
              Designed by @danmcbabe
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
